import type { InstagramAccount } from '../types';

import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { instagramQueries } from '../model/queries';
import { useConnectInstagram } from '../model/useConnectInstagram';

export function useEnsureInstagramConnection(pharmacyId: string) {
  const queryClient = useQueryClient();
  const { mutateAsync: connect } = useConnectInstagram(pharmacyId);

  const fetchAccount = useCallback(
    () => queryClient.fetchQuery(instagramQueries.account(pharmacyId)),
    [pharmacyId, queryClient]
  );

  const ensureConnected =
    useCallback(async (): Promise<InstagramAccount | null> => {
      const account = await fetchAccount();

      if (account?.isTokenExpired === false) {
        return account;
      }

      try {
        const result = await connect();

        return result ? await fetchAccount() : null;
      } catch {
        return null;
      }
    }, [connect, fetchAccount]);

  return { ensureConnected };
}
